import React from 'react';
import { map } from 'lodash';

import { getNodeLabel } from '../Network/networkUtils';
import styles from './tableStyles.module.scss';

export const Table = ({ inboundCount, outboundCount, totalCount, nodes }) => {
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.th}>Contact</th>
            <th className={styles.th}>Inbound</th>
            <th className={styles.th}>Outbound</th>
            <th className={styles.th}>Total</th>
          </tr>
        </thead>
        <tbody>
          {map(nodes, node => (
            <tr key={node.id}>
              <td className={styles.td}>{getNodeLabel(node.metadata)}</td>
              <td className={styles.td}>{inboundCount[node.id]}</td>
              <td className={styles.td}>{outboundCount[node.id]}</td>
              <td className={styles.td}>{totalCount[node.id]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
